<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">

    <!-- ======================================================= -->
    <!-- Header fixo                                              -->
    <!-- ======================================================= -->
    <div class="flex-shrink-0 flex items-center justify-between px-5 it:px-6 py-4 border-b border-gray-200">
        <div class="flex items-center gap-3 min-w-0">
            <div class="w-10 h-10 rounded-full bg-[#0061ff]/10 flex items-center justify-center flex-shrink-0">
                <mat-icon class="icon-size-6 text-[#0061ff]" [svgIcon]="'mat_solid:support_agent'"></mat-icon>
            </div>
            <div class="min-w-0">
                <h2 class="text-[20px] font-remote font-semibold text-gray-900 m-0 leading-tight truncate">Ajuda</h2>
                <p class="text-[12px] font-inter text-gray-400 m-0 truncate">Pergunte ao assistente ou consulte os artigos</p>
            </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0">
            <button
                *ngIf="activeTab === 'chat'"
                (click)="newConversation()"
                [disabled]="messages.length === 0 && !conversationId && !sending"
                class="hidden it:flex items-center gap-1 px-4 py-2 rounded-3xl bg-white border border-gray-200 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <mat-icon class="icon-size-4 text-gray-600" [svgIcon]="'mat_solid:add'"></mat-icon>
                <span class="text-[13px] font-inter font-medium text-gray-600">Nova conversa</span>
            </button>
            <button
                mat-icon-button
                (click)="closeModal()"
                class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
                <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- ======================================================= -->
    <!-- Abas (barra border-b + ativa border-b-4 #0061ff)          -->
    <!-- ======================================================= -->
    <div class="flex-shrink-0 flex border-b border-gray-200 font-inter text-[14px] font-[500] px-4 it:px-6">
        <div
            (click)="selectTab('chat')"
            class="cursor-pointer px-4 py-3 flex items-center gap-2 whitespace-nowrap border-b-4 transition-colors"
            [ngClass]="activeTab === 'chat' ? 'border-b-[#0061ff] text-[#0061ff]' : 'border-b-transparent text-gray-500 hover:text-gray-700'">
            <mat-icon class="icon-size-5" [svgIcon]="'mat_solid:chat'"></mat-icon>
            <span>Conversar</span>
        </div>
        <div
            (click)="selectTab('articles')"
            class="cursor-pointer px-4 py-3 flex items-center gap-2 whitespace-nowrap border-b-4 transition-colors"
            [ngClass]="activeTab === 'articles' ? 'border-b-[#0061ff] text-[#0061ff]' : 'border-b-transparent text-gray-500 hover:text-gray-700'">
            <mat-icon class="icon-size-5" [svgIcon]="'mat_solid:menu_book'"></mat-icon>
            <span>Artigos</span>
        </div>
    </div>

    <!-- ======================================================= -->
    <!-- Aba: Conversar                                            -->
    <!-- ======================================================= -->
    <div *ngIf="activeTab === 'chat'" class="flex flex-col flex-1 min-h-0">

        <!-- Mensagens -->
        <div #messagesContainer class="flex-1 min-h-0 overflow-y-auto px-5 it:px-6 py-5 space-y-4 bg-gray-50">

            <!-- Estado vazio: boas-vindas + sugestões -->
            <div *ngIf="!sending && messages.length === 0" class="flex flex-col items-center justify-center h-full text-center">
                <div class="w-16 h-16 rounded-full bg-[#0061ff]/10 flex items-center justify-center mb-4">
                    <mat-icon class="icon-size-8 text-[#0061ff]" [svgIcon]="'mat_solid:question_answer'"></mat-icon>
                </div>
                <h3 class="text-[18px] font-remote font-semibold text-gray-900 mb-2">Como posso ajudar?</h3>
                <p class="text-[13px] font-inter text-gray-500 max-w-md mb-6">
                    Pergunte como fazer algo no sistema — o assistente responde com passos práticos citando o artigo de origem.
                </p>
                <div class="flex flex-wrap justify-center gap-2">
                    <button
                        *ngFor="let suggestion of suggestions"
                        (click)="sendSuggestion(suggestion)"
                        class="px-4 py-2 rounded-full bg-white border border-gray-200 hover:border-[#0061ff] hover:text-[#0061ff] text-[13px] font-inter text-gray-700 transition-colors">
                        {{ suggestion }}
                    </button>
                </div>
            </div>

            <!-- Mensagens -->
            <ng-container *ngFor="let message of messages">
                <!-- Usuário (direita, fundo azul #0061ff) -->
                <div *ngIf="message.role === 'user'" class="flex justify-end">
                    <div class="max-w-[80%] px-4 py-2.5 bg-[#0061ff] text-white rounded-2xl rounded-br-md text-[15px] font-inter leading-relaxed whitespace-pre-line">
                        {{ message.content }}
                    </div>
                </div>

                <!-- Assistente (esquerda) -->
                <div *ngIf="message.role === 'assistant'" class="flex items-start gap-2">
                    <div class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <mat-icon class="icon-size-4 text-gray-500" [svgIcon]="'mat_solid:support_agent'"></mat-icon>
                    </div>
                    <div class="flex-1 min-w-0">
                        <div
                            class="help-chat-answer help-chat-markdown bg-white border border-gray-200 rounded-2xl rounded-tl-md px-4 py-3 text-[15px] font-inter text-gray-800 leading-relaxed"
                            [innerHTML]="message.renderedHtml"></div>

                        <!-- Fonte citada (chip clicável → aba Artigos) -->
                        <div *ngIf="message.sourceArticle" class="mt-2">
                            <button
                                (click)="openSourceArticle(message.sourceArticle)"
                                class="inline-flex items-center gap-1.5 max-w-full px-3 py-1.5 rounded-full bg-[#eff7ff] hover:bg-[#dcede9] text-[#0061ff] text-[12px] font-inter transition-colors">
                                <mat-icon class="icon-size-4 flex-shrink-0" [svgIcon]="'mat_solid:description'"></mat-icon>
                                <span class="truncate">{{ message.sourceArticle.title }}</span>
                            </button>
                        </div>

                        <!-- Followups sugeridos -->
                        <div *ngIf="message.suggestedFollowups && message.suggestedFollowups.length > 0" class="mt-3">
                            <span class="text-[12px] font-inter text-gray-400 block mb-1.5">Perguntas relacionadas:</span>
                            <div class="flex flex-wrap gap-2">
                                <button
                                    *ngFor="let followup of message.suggestedFollowups"
                                    (click)="sendFollowup(followup)"
                                    class="px-3 py-1.5 rounded-full bg-white border border-gray-200 hover:border-[#0061ff] hover:text-[#0061ff] text-[12px] font-inter text-gray-600 transition-colors">
                                    {{ followup.title }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Status rotativo do assistente (SEM bolha de mensagem — frases giram a cada ~2s enquanto aguarda o LLM) -->
            <div *ngIf="sending" class="flex items-start gap-2">
                <div class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <mat-icon class="icon-size-4 text-gray-500" [svgIcon]="'mat_solid:support_agent'"></mat-icon>
                </div>
                <div class="flex-1 min-w-0 pt-1.5">
                    <p class="help-chat-status text-[13px] font-inter text-gray-500 italic animate-pulse leading-relaxed">{{ activeStatusPhrase }}</p>
                </div>
            </div>
        </div>

        <!-- Banner de erro da conversa (402/429/503/422) — não trava o input -->
        <div *ngIf="chatError"
             class="flex-shrink-0 mx-5 it:mx-6 mb-2 rounded-xl bg-red-50 text-red-700 px-4 py-2.5 text-[13px] font-inter flex items-center gap-2">
            <mat-icon class="icon-size-4 flex-shrink-0" [svgIcon]="'mat_solid:error_outline'"></mat-icon>
            <span class="flex-1">{{ chatError }}</span>
            <button (click)="chatError = null" class="flex-shrink-0 text-red-500 hover:text-red-700 transition-colors">
                <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:close'"></mat-icon>
            </button>
        </div>

        <!-- Input inferior fixo -->
        <div class="flex-shrink-0 px-5 it:px-6 py-4 border-t border-gray-200 bg-white flex items-center gap-3">
            <mat-form-field class="flex-1 min-w-0" appearance="fill" subscriptSizing="dynamic">
                <input
                    matInput
                    [(ngModel)]="inputMessage"
                    (keydown.enter)="sendMessage()"
                    [disabled]="sending"
                    placeholder="Digite sua pergunta sobre o sistema...">
            </mat-form-field>
            <button
                (click)="sendMessage()"
                [disabled]="!inputMessage.trim() || sending"
                class="w-12 h-12 rounded-full bg-[#0061ff] hover:bg-[#2f75e7] disabled:bg-gray-200 disabled:cursor-not-allowed flex items-center justify-center transition-colors flex-shrink-0"
                [attr.aria-label]="'Enviar mensagem'">
                <mat-spinner *ngIf="sending" [diameter]="22" class="spinner-white"></mat-spinner>
                <mat-icon *ngIf="!sending" class="icon-size-5 text-white" [svgIcon]="'mat_solid:send'"></mat-icon>
            </button>
        </div>
    </div>

    <!-- ======================================================= -->
    <!-- Aba: Artigos                                              -->
    <!-- ======================================================= -->
    <div *ngIf="activeTab === 'articles'" class="flex flex-col flex-1 min-h-0 bg-gray-50">

        <!-- =============== Listagem =============== -->
        <ng-container *ngIf="articlesView === 'list'">

            <!-- Busca + categorias (fixas) -->
            <div class="flex-shrink-0 px-5 it:px-6 pt-4 space-y-3 border-b border-gray-200 bg-gray-50">
                <mat-form-field class="w-full" appearance="fill" subscriptSizing="dynamic">
                    <mat-icon matPrefix class="icon-size-5 text-gray-400 mr-2" [svgIcon]="'mat_solid:search'"></mat-icon>
                    <mat-label>Buscar um artigo...</mat-label>
                    <input
                        matInput
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onSearchChange($event)"
                        placeholder="Ex.: dízimo, comprovante, relatório">
                </mat-form-field>

                <div class="flex items-center gap-2 overflow-x-auto pb-3">
                    <button
                        (click)="selectCategory('')"
                        class="px-3 py-1 rounded-full text-[11px] font-inter whitespace-nowrap transition-colors"
                        [ngClass]="selectedCategory === '' ? 'bg-[#0061ff] text-white' : 'bg-white border border-gray-200 text-gray-600 hover:border-[#0061ff]'">
                        Todas
                    </button>
                    <button
                        *ngFor="let category of categories"
                        (click)="selectCategory(category)"
                        class="px-3 py-1 rounded-full text-[11px] font-inter whitespace-nowrap transition-colors"
                        [ngClass]="selectedCategory === category ? 'bg-[#0061ff] text-white' : 'bg-white border border-gray-200 text-gray-600 hover:border-[#0061ff]'">
                        {{ category }}
                    </button>
                </div>
            </div>

            <!-- Lista -->
            <div class="flex-1 min-h-0 overflow-y-auto px-5 it:px-6 py-4 space-y-2">

                <!-- Banner de erro da listagem -->
                <div *ngIf="articlesError"
                     class="rounded-xl bg-red-50 text-red-700 px-4 py-2.5 text-[13px] font-inter flex items-center gap-2 mb-2">
                    <mat-icon class="icon-size-4 flex-shrink-0" [svgIcon]="'mat_solid:error_outline'"></mat-icon>
                    <span class="flex-1">{{ articlesError }}</span>
                    <button (click)="articlesError = null" class="flex-shrink-0 text-red-500 hover:text-red-700 transition-colors">
                        <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:close'"></mat-icon>
                    </button>
                </div>

                <!-- Loading da primeira carga -->
                <div *ngIf="articlesLoading && articles.length === 0" class="flex items-center justify-center py-10">
                    <mat-spinner [diameter]="28" class="text-[#0061ff]"></mat-spinner>
                </div>

                <ng-container *ngIf="!articlesLoading || articles.length > 0">
                    <!-- Cards de artigo -->
                    <div
                        *ngFor="let article of articles; trackBy: trackBySlug"
                        (click)="openArticle(article.slug)"
                        class="bg-white rounded-xl border border-gray-100 hover:border-[#0061ff]/50 hover:shadow-sm p-4 cursor-pointer transition-all">
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-inter bg-[#eff7ff] text-[#0061ff]">
                            {{ article.category }}
                        </span>
                        <h3 class="mt-1.5 text-[15px] font-semibold font-inter text-gray-900">{{ article.title }}</h3>
                        <p class="mt-1 text-[13px] font-inter text-gray-500 line-clamp-2">{{ article.summary }}</p>
                    </div>

                    <!-- Resultado vazio -->
                    <div *ngIf="articles.length === 0 && !articlesLoading" class="flex flex-col items-center justify-center py-12 text-center">
                        <mat-icon class="icon-size-8 text-gray-300 mb-3" [svgIcon]="'mat_solid:search_off'"></mat-icon>
                        <p class="text-[14px] font-inter text-gray-500">Nenhum artigo encontrado.</p>
                        <p class="text-[12px] font-inter text-gray-400 mt-1">Tente ajustar a busca ou escolher outra categoria.</p>
                    </div>

                    <!-- Carregar mais -->
                    <div *ngIf="articlesMeta && articlesMeta.current_page < articlesMeta.last_page" class="flex items-center justify-center pt-2 pb-4">
                        <button
                            (click)="loadMoreArticles()"
                            [disabled]="articlesLoadingMore"
                            class="px-5 py-2 rounded-3xl bg-white border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed text-gray-700 text-[13px] font-inter flex items-center gap-2 transition-colors">
                            <mat-spinner *ngIf="articlesLoadingMore" [diameter]="16" class="text-[#0061ff]"></mat-spinner>
                            <span *ngIf="!articlesLoadingMore">Carregar mais</span>
                            <span *ngIf="articlesLoadingMore">Carregando...</span>
                        </button>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <!-- =============== Leitura do artigo =============== -->
        <ng-container *ngIf="articlesView === 'detail'">
            <div class="flex-1 min-h-0 overflow-y-auto px-5 it:px-6 py-5">

                <button
                    (click)="backToList()"
                    class="inline-flex items-center gap-1.5 text-[13px] font-inter text-gray-600 hover:text-[#0061ff] transition-colors mb-4">
                    <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:arrow_back'"></mat-icon>
                    Voltar para a lista
                </button>

                <!-- Banner de erro da leitura -->
                <div *ngIf="articlesError"
                     class="rounded-xl bg-red-50 text-red-700 px-4 py-2.5 text-[13px] font-inter flex items-center gap-2 mb-4">
                    <mat-icon class="icon-size-4 flex-shrink-0" [svgIcon]="'mat_solid:error_outline'"></mat-icon>
                    <span class="flex-1">{{ articlesError }}</span>
                    <button (click)="articlesError = null" class="flex-shrink-0 text-red-500 hover:text-red-700 transition-colors">
                        <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:close'"></mat-icon>
                    </button>
                </div>

                <!-- Loading -->
                <div *ngIf="!selectedArticle && !articlesError" class="flex items-center justify-center py-10">
                    <mat-spinner [diameter]="28" class="text-[#0061ff]"></mat-spinner>
                </div>

                <div *ngIf="selectedArticle">
                    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-inter bg-[#eff7ff] text-[#0061ff]">
                        {{ selectedArticle.category }}
                    </span>
                    <h2 class="mt-2 text-[20px] font-remote font-semibold text-gray-900 leading-snug">{{ selectedArticle.title }}</h2>
                    <p class="mt-1.5 text-[13px] font-inter text-gray-500">{{ selectedArticle.summary }}</p>

                    <div class="mt-5 space-y-3">
                        <p
                            *ngFor="let paragraph of articleParagraphs"
                            class="text-[14px] font-inter text-gray-700 leading-relaxed whitespace-pre-line">
                            {{ paragraph }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>